import textStyles from '../TextMenu.module.css'
import {Helmet} from "react-helmet";
import React from "react";
import {inspect} from "util";
export default function MenuChoose(){
    const vidWidth =  window.innerWidth-60 < 720 ? window.innerWidth-60 : 720

    return(
        <div className={textStyles.mainCont}>
            <Helmet>
                <title>sim-unlim : О нас</title>
                <link rel="canonical" href="https://sim-unlim.com/choose" />
                <meta name="description" content="Партнеры мегафон tele2 t2 beeline билайн yota йота мтс mts паспорт госуслуги" />
            </Helmet>
            <div className={textStyles.blCont}>
                <div className={textStyles.head}><p>Почему стоит выбрать подключение у нас</p></div>
                <div className={textStyles.vidCont}>
                    <iframe width={vidWidth} height={vidWidth/1.77}  src="https://rutube.ru/play/embed/fb9bb753389c10cace975e6202fc6a5e/?sTitle=false&player=hideControls" frameBorder="0" allow="clipboard-write; autoplay" ></iframe>
                </div>


                <p className={textStyles.ident}>
                    Компания sim-unlim является официальным дилером операторов мобильной связи РФ. Мы работаем на рынке мобильной связи с 2012 года, за это время наша компания подключила более 30 000 клиентов.
                </p>
                <p className={textStyles.ident}>
                    sim-unlim предлагает выгодные тарифы на мобильную связь, которые Вы не сможете приобрести напрямую у оператора. Вам доступен заказ новой сим-карты или переход со своим номером. Приобретая сим-карту у нас на сайте, Вы можете заказать доставку или забрать покупку самостоятельно в офисах компании.

                </p>
                <p className={textStyles.ident}>
                    Мы соблюдаем законодательство РФ в области связи, поэтому работать с нами безопасно и надежно.

                </p>
                <p className={textStyles.pX}>
                    <span className={textStyles.bold}>
                        Что за тарифы мы подключаем?
                    </span>
                </p>
                <p className={textStyles.ident}>
                    На витрине  представлены эксклюзивные тарифы, которые Вы не сможете подключить самостоятельно, обратившись к оператору связи. Основное преимущество представленных тарифов – низкая стоимость при  более емком  наполнении.
                </p>
                <p className={textStyles.pX}>
                    <span className={textStyles.bold}>
                    Как это возможно?
                    </span>

                </p>
                <p className={textStyles.ident}>
                    В списке клиентов и партнеров sim-unlim: МВД, РЖД, Генерирующие компании и т.д. Операторы мобильной связи разработали специальные «секретные» тарифные планы для крупнейших корпораций, которые недоступны в салонах связи. Эти тарифы мы предлагаем нашим клиентам на абсолютно легальных основаниях с официальной регистрацией на паспортные данные Клиента.
                    Кроме получения выгодных цен на связь, Вы можете подключиться к нашей партнерской программе и зарабатывать вместе с нами!
                </p>

                <p style={{display:"none"}}>


                    Мы являемся партнерами большой тройки операторов мобильной связи. Работаем более 12 лет, по этому нам доступны специальные тарифные планы, которые не доступны в салонах связи.
                    Мы продаем тарифы, которые оформляются на конечных пользователей, и не получится так, что их кто-то Вам отключит. Вам будут доступны личные кабинеты наравне с обычными пользователями.
                    Нам доступны предложения с более емкими наполнением тарифов при меньшей цене, чем в салонах. Мы не гонимся за прибылью, мы не продаем тарифы по космическим ценам, цена продажи больше складывается
                    из услуг по оформлению. Наша цель не продать тариф, а сделать благо для пользователя, так как  покупая тариф в среднем за 600 руб. клиент уже получает экономию от ежемесяцных платежей, пересчитывая на год
                    Вы уже получите солидную экономию, это не считая того, что в наших тарифах наполнение намного лучше (минуты, гигабайты и тп). Мы так же осуществляем перенос номеров (MNP)
                    с возможностью проверить  возможность переноса on-line.





                </p>
            </div>
        </div>
    )
}